import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { IncidentTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentTypeCreateDto,
  IncidentTypeDto,
  IncidentTypeExcelDownloadDto,
  IncidentTypeUpdateDto,
} from '../proxy/planning/dtos/incident-type';
import { INCIDENTTYPE_CONFIG, INCIDENTTYPE_FIELDS } from './incident-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentTypeService, ConfirmationService],
  templateUrl: './incident-type.html',
  styleUrl: './incident-type.scss',
})
export class IncidentType extends BaseCrudComponent<
  IncidentTypeDto,
  IncidentTypeCreateDto,
  IncidentTypeUpdateDto,
  IncidentTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(IncidentTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('IncidentType', ids),
  };
  config = INCIDENTTYPE_CONFIG;
  fields = INCIDENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentTypeDto): IncidentTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentType';
  }
}
